import type { Tenant } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '../../utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

const fields: FormItem<Tenant>[] = [
  {
    cssClass: 'tmm-section',
    colCount: {
      xs: 1,
      sm: 1,
      md: 2,
      lg: 2,
    },
    items: [
      allFields.name,
      allFields.tisId,
      allFields.cognitoGroupName,
      allFields.plan,
      { ...allFields.address, colSpan: 2 },
      { ...allFields.contacts, colSpan: 2 },
      allFields.isActive,
    ],
  },
  getHistorySection(),
];

export default fields;
